const rankItems = [
  { rank: 1, title: '某知名导演被多名女演员联合实名举报', heat: '🔥 326.8万', trend: 'up' },
  { rank: 2, title: '当红小生被爆同时交往三位女友时间线整理', heat: '🔥 289.5万', trend: 'up' },
  { rank: 3, title: '热门剧集编剧疑似抄袭，对比截图全网疯传', heat: '🔥 245.1万', trend: 'new' },
  { rank: 4, title: '综艺录制现场嘉宾口误爆出惊人内幕', heat: '🔥 198.7万', trend: 'up' },
  { rank: 5, title: '某女艺人深夜发文暗示退圈粉丝炸锅', heat: '🔥 176.3万', trend: 'new' },
  { rank: 6, title: '品牌代言人争夺战白热化多方下场开撕', heat: '🔥 152.4万', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            吃瓜榜单
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            51吃瓜视频网实时热度排行，最受关注的吃瓜内容TOP6
          </p>
        </div>
        <div className="space-y-3">
          {rankItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 border border-background-200/70 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                <span className={`text-xs font-medium flex items-center gap-0.5 whitespace-nowrap ${
                  item.trend === 'up' ? 'text-primary-600' : 'text-accent-600'
                }`}>
                  <i className={`${item.trend === 'new' ? 'ri-sparkling-line' : 'ri-arrow-up-line'} text-xs`}></i>
                  {item.trend === 'new' ? '新上榜' : '上升'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}